import { authFetch, authHeaders, resolveApiBaseUrl } from '../auth';
import { apiUrl } from './http';

export const migrationMethods = {
// Migrate localStorage data to database (one-time operation)
  async migrateLocalStorageData() {
    try {
      const orderData = {};
      const disputeData = {};
      const emailData = {};

      // Extract data from localStorage
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        const value = localStorage.getItem(key);

        if (key.startsWith('order_') && key.includes('_status')) {
          const orderId = key.split('_')[1];
          orderData[orderId] = orderData[orderId] || {};
          orderData[orderId].status = value;
        } else if (key.startsWith('order_') && key.includes('_tracking')) {
          const orderId = key.split('_')[1];
          orderData[orderId] = orderData[orderId] || {};
          orderData[orderId].tracking = value;
        } else if (key.startsWith('dispute_')) {
          const orderId = key.split('_')[1];
          disputeData[orderId] = JSON.parse(value);
        } else if (key.startsWith('email_sent_') || key.startsWith('email_failed_')) {
          const parts = key.split('_');
          const orderId = parts[2];
          const status = parts[3];
          const type = parts[1]; // sent or failed
          emailData[`${orderId}_${status}`] = { type, value };
        }
      }


      // Here you would call migration endpoints if needed
      // For now, just return the data for manual processing
      return {
        success: true,
        message: 'localStorage data extracted successfully',
        data: {
          orders: orderData,
          disputes: disputeData,
          emails: emailData
        }
      };
    } catch (error) {
      console.error('Migration failed:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }
};
